import React from 'react';

const Chevron: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M5 12.5L10 7.5L15 12.5" stroke="#344054" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default Chevron;
